import PropTypes from 'prop-types'

export default function Notice({ children, type = 'info' }) {
  return (
    <div
      data-testid="notice"
      className={`tw-p-5 tw-text-base tw-rounded tw-max-w-screen-lg tw-border ${
        type === 'info' ? 'tw-border-primary-200 ' : 'tw-border-secondary-100'
      }`}>
      <p className="tw-m-0">{children}</p>
    </div>
  )
}

Notice.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['info', 'warning']),
}
